import { forwardRef } from 'react';
import { Button, Badge, styled } from '@mui/material';


const Root = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ theme }) => ({
    boxSizing: 'border-box',
    minWidth: 'auto',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.mode === 'dark'
        ? theme.palette.neutral.light
        : theme.palette.neutral.lightest,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: theme.palette.mode === 'dark'
            ? theme.palette.neutral.mid
            : theme.palette.neutral.light,
    },
}));

const BADGE_SX = {
    '& .MuiBadge-badge': {
        minWidth: 14,
        height: 14,
        padding: '0 2px',
    },
};

const StyledButton = forwardRef(({ 
    badge, 
    badgeColor = 'primary', 
    ...props 
}, ref) => {
    const button = <Root ref={ref} {...props} />;
    if (!badge) return button;
    return (
        <Badge badgeContent={badge} color={badgeColor} sx={BADGE_SX}>
            {button}
        </Badge>
    );
});

StyledButton.displayName = 'StyledButton';

export default StyledButton;
